export default __webpack_public_path__ + "static/media/Group140.1fefdb84.png";